'use client';

import React from 'react';
import { IconFeedback, IconUserCheck } from '@repo/svgs';
import { SectionHeader } from '@/components/ui/SectionHeader';
import { DataCell, Divider } from '@/components/ui';
import { useOwner } from '../../context/OwnerProvider';
import { cn } from '@/lib/cn';

export function OwnerRenterRecommendations() {
  const { aggResponse, isMasked } = useOwner();

  return (
    <div className="flex flex-col w-full">
      {/* Section Header */}
      <SectionHeader title="Renter recommendations" />

      {/* Content */}
      <div className={cn('md:px-2')}>
        <div className="grid grid-cols-1 md:grid-cols-2 md:gap-4">
          <DataCell
            icon={<IconFeedback className="w-6 h-6 icon-secondary" />}
            value={`${aggResponse?.recommendPerc ?? '-'}%`}
            description="Renters recommend associated buildings"
            isMasked={isMasked}
          />

          <div className="flex items-center justify-center md:hidden py-1">
            <Divider />
          </div>

          <DataCell
            icon={<IconUserCheck className="w-6 h-6 icon-secondary" />}
            value={`${aggResponse?.approvePerc ?? '-'}%`}
            description="Renters approve of this owner or associate"
            isMasked={isMasked}
          />
        </div>
      </div>
    </div>
  );
}
